import {v4 as uuidv4} from 'uuid';

export function getCurrentUrlPath(urlToRedirect) {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    const path = url.pathname;
    return path;
  }
  return null;
}

export function redirectToSameWindowWithRefresh(urlToRedirect) {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    const crId = params.get('crId');

    const id = crId || uuidv4();
    if (typeof window !== 'undefined') {
      window.open(`${urlToRedirect}?crId=${id}`, '_self');
    }
  }
}

export function redirectToSameWindowWithoutRefresh(urlToRedirect) {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    const crId = params.get('crId');

    const id = crId || uuidv4();
    const newUrl = `${urlToRedirect}?crId=${id}`;
    if (typeof window !== 'undefined' && crId == null) {
      window.history.replaceState({}, '', newUrl);
    } else {
      window.history.replaceState({}, '', urlToRedirect);
    }
  }
}

export function getCrid() {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    return params.get('crId');
  }
}

export const getUrlWithCrid = url => {
  const crId = getCrid() || uuidv4();
  return `${url}?crId=${crId}`;
};

export const returnNewCrid = () => {
  return uuidv4();
};

export const updateUrlWithNewCrid = url => {
  if (typeof window !== 'undefined') {
    const currentUrl = window.location.href;
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => {
        if (prop in URLSearchParams.prototype) {
          return searchParams[prop];
        }
        return searchParams.get(prop);
      },
    });
    if (typeof window !== 'undefined') {
      const crId = params.crId;
      if (window.location.host && !crId) {
        history.replaceState(null, '', `${currentUrl}?crId=${returnNewCrid()}`);
      }
    }
  }
};
